/* Break Boss theme JS. Wires the design to Shopify's AJAX cart.
   Kept intentionally small: add-to-cart, live cart count, and a slide-in
   confirmation drawer. Predictive search and richer drawer come next. */
(function () {
  "use strict";
  var routes = window.routes || {};

  function money(cents) {
    try { return "$" + (cents / 100).toFixed(2); } catch (e) { return ""; }
  }

  function setCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = n; });
  }

  function toast(msg) {
    var t = document.createElement("div");
    t.className = "bb-toast";
    t.textContent = msg;
    t.style.cssText = "position:fixed;right:18px;bottom:18px;z-index:200;background:#0E1110;color:#fff;font-family:Archivo,sans-serif;font-weight:700;padding:13px 18px;border-radius:10px;box-shadow:0 12px 30px rgba(0,0,0,.28);opacity:0;transform:translateY(8px);transition:.25s";
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = "1"; t.style.transform = "none"; });
    setTimeout(function () { t.style.opacity = "0"; setTimeout(function () { t.remove(); }, 300); }, 2600);
  }

  function refreshCount() {
    if (!routes.cart_url) return;
    fetch(routes.cart_url + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }

  // Intercept add-to-cart forms for an AJAX add (falls back to normal POST on error)
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[data-cart-add]");
    if (!form || !routes.cart_add_url) return;
    // If a variant must be chosen on the PDP, let the card link route there instead
    var chooser = form.querySelector("[data-choose]");
    if (chooser) { e.preventDefault(); window.location.href = chooser.getAttribute("data-choose"); return; }
    e.preventDefault();
    var btn = form.querySelector("button[type=submit]");
    var label = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Adding..."; }
    var data = new FormData(form);
    fetch(routes.cart_add_url + ".js", { method: "POST", body: data, headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body.description || "Could not add to cart"); return; }
        toast("Added to cart");
        refreshCount();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  // Cart button: on the cart page setting "drawer", clicking goes to cart page for now.
  document.addEventListener("DOMContentLoaded", refreshCount);

  // Safety net: base.css (ported from the prototype) ships .reveal{opacity:0},
  // but the prototype JS that revealed those elements was not ported. If any
  // template ever uses the class, reveal it on scroll with a hard fallback so
  // content is never left invisible (lesson learned twice on the prototype).
  document.addEventListener("DOMContentLoaded", function () {
    var els = document.querySelectorAll(".reveal:not(.in)");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      document.querySelectorAll(".reveal:not(.in)").forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add("in");
      });
    }, 3000);
  });
})();
